import $i18n from '@/locale-view/i18n';
import { ButtonPosition } from '@/common/manager/position/button-position';
import { CnMessage } from '@cainiaofe/cn-ui';
import { makeRequest } from '@/common/util/request';
export const config = {
    value: 'batch',
    position: [ButtonPosition.tableBatchArea],
    action: ({ buttonConfig, selectedRowKeys, selectedRowRecords, tableRef, urlParamsDataSource, recordDataSource, state, position, }) => {
        if (selectedRowKeys?.length > 0) {
            return makeRequest({
                position,
                buttonConfig,
                urlParamsDataSource,
                recordDataSource,
                state,
                extraParamList: [selectedRowKeys, selectedRowRecords],
                handleParams: () => {
                    return {
                        selectedRowKeys,
                        selectedRowRecords,
                    };
                },
            }).then(() => {
                tableRef?.load?.();
            });
        }
        else {
            CnMessage.error($i18n.get({ id: 'PleaseSelectTableData', dm: '请选择表格数据' }));
            return Promise.reject();
        }
    },
};
